import { useEffect, useState } from 'react';
import { getEcrService } from '@/services/ecrService';
import type { RepositoryName } from '@/services/imageTagService';
import type { ImagesByChannel } from '@/utils/deployStatus';

/**
 * The images of one channel, to show a run's image by its given name in place
 * of its tag. Undefined until they arrive, and when they cannot be read: the
 * page then shows the tag, which is always on the run itself.
 */
export function useDeployImages(repository?: RepositoryName): ImagesByChannel | undefined {
  const [images, setImages] = useState<ImagesByChannel | undefined>();
  useEffect(() => {
    if (!repository) return;
    let cancelled = false;
    getEcrService(repository)
      .getAllImages()
      .then((list) => {
        if (cancelled) return;
        setImages({ 'numa-deploy': [], 'numa-deploy-dev': [], [repository]: list });
      })
      .catch((e) => console.warn('Could not read image names', e));
    return () => {
      cancelled = true;
    };
  }, [repository]);
  return images;
}
